import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {CityService} from '@services/city.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-widget-repartition',
    templateUrl: './repartition.component.html',
    styleUrls: ['./repartition.component.scss']
})
export class RepartitionComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();

    tabs = 'country';
    secteur = '';
    iris = '';

    compare = [];
    compare_1 = [];
    compare_2 = [];
    displayedColumns: string[] = ['lib', 'quartier', 'secteur', 'ville', 'france'];

    options = {
        tooltip: {
            trigger: 'item',
            formatter: '{b} : {c}%'
        },
        legend: {
            show: false,
            left: 'center',
        },
        calculable: true,
        series: [
            {
                name: 'Proportion locataires / propriétaires',
                type: 'pie',
                data: []
            }
        ]
    };


    data = {
        series: []
    };


    constructor(
        public cityService: CityService,
        public deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        if (this.favorite.iris != ''
            && this.favorite.ad_city.mapping_quartier_iris != null
            && this.favorite.ad_city.mapping_quartier_iris.quartier != null) {
            this.tabs = 'quartier';
        }
        this.iris = this.favorite.iris;
        if (this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length == 1) {
            // this.secteur = this.favorite.ad_city.mapping_quartier_iris.quartier[0].GQ_c;
            // this.iris = this.secteur;
            this.displayedColumns = ['lib', 'quartier', 'ville', 'france'];
        }
        if (!this.favorite.ad_city.mapping_quartier_iris || !this.favorite.ad_city.mapping_quartier_iris.quartier) {
            this.displayedColumns = ['lib', 'ville', 'france'];
        }

        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
    }

    setData() {
        if (this.iris != '') {
            this.secteur = this.iris.substring(0, 7);
        }

        let irisData = null;
        if (this.iris != '' && this.favorite.ad_city.logement_iris[this.iris]) {
            irisData = this.favorite.ad_city.logement_iris[this.iris];
        }

        let secteurData = null;
        if (this.secteur != '' && this.favorite.ad_city.logement_gq[this.secteur]) {
            secteurData = this.favorite.ad_city.logement_gq[this.secteur];
        }

        let root = this.favorite.ad_city.logement;
        if (this.tabs == 'quartier') {
            if (this.secteur == '') {
                // Tout la ville = nothing
            } else if (this.iris.length == 7 && secteurData) {
                root = secteurData;
            } else if (this.iris.length > 7 && irisData) {
                root = irisData;
            }
        }

        this.data = {
            series: [
                {
                    name: 'Proportion locataires / propriétaires',
                    type: 'pie',
                    center: ['25%', '25%'],
                    radius: ['0%', '35%'],
                    color: ['#FFD566', '#67C3EF'],
                    data: [
                        {value: Math.round(root.T_PROP * 100), name: 'Propiétaires'},
                        {value: Math.round(root.T_LOC * 100), name: 'Locataires'},
                    ]
                },
                {
                    name: '',
                    type: 'pie',
                    center: ['75%', '25%'],
                    radius: ['0%', '35%'],
                    color: ['#9C9C9C', '#78C447'],
                    data: [
                        {value: Math.round(root.T_Appt * 100), name: 'Appartements'},
                        {value: Math.round(root.T_Mai * 100), name: 'Maisons'},
                    ]
                },
                {
                    name: '',
                    type: 'pie',
                    center: ['50%', '75%'],
                    radius: ['0%', '35%'],
                    color: ['#1277AA', '#FABB3D', '#FF5455'],
                    data: [
                        {value: Math.round(root.T_RP * 100), name: 'Résidences principales'},
                        {value: Math.round(root.T_RS * 100), name: 'Résidences secondaires'},
                        {value: Math.round(root.T_LV * 100), name: 'Logements vacants'},
                    ]
                }
            ]
        };

        if (this.deviceService.isMobile()) {
            this.data.series[0].center = ['50%', '15%'];
            this.data.series[0].radius = ['0%', '25%'];
            this.data.series[1].center = ['50%', '45%'];
            this.data.series[1].radius = ['0%', '25%'];
            this.data.series[2].center = ['50%', '80%'];
            this.data.series[2].radius = ['0%', '25%'];
        }

        this.compare = [
            {
                'lib': 'Propiétaires',
                'quartier': (irisData != null ? (irisData.T_PROP * 100).toFixed(1) : '-'),
                'secteur': (secteurData != null ? (secteurData.T_PROP * 100).toFixed(1) : '-'),
                'ville': (this.favorite.ad_city.logement.T_PROP * 100).toFixed(1),
                'france': (this.favorite.ad_city.logement_fr.T_PROP * 100).toFixed(1),
            },
            {
                'lib': 'Locataires',
                'quartier': (irisData != null ? (irisData.T_LOC * 100).toFixed(1) : '-'),
                'secteur': (secteurData != null ? (secteurData.T_LOC * 100).toFixed(1) : '-'),
                'ville': (this.favorite.ad_city.logement.T_LOC * 100).toFixed(1),
                'france': (this.favorite.ad_city.logement_fr.T_LOC * 100).toFixed(1),
            },
        ];
        this.compare_1 = [
            {
                'lib': 'Appartements',
                'quartier': (irisData != null ? (irisData.T_Appt * 100).toFixed(1) : '-'),
                'secteur': (secteurData != null ? (secteurData.T_Appt * 100).toFixed(1) : '-'),
                'ville': (this.favorite.ad_city.logement.T_Appt * 100).toFixed(1),
                'france': (this.favorite.ad_city.logement_fr.T_Appt * 100).toFixed(1),
            },
            {
                'lib': 'Maisons',
                'quartier': (irisData != null ? (irisData.T_Mai * 100).toFixed(1) : '-'),
                'secteur': (secteurData != null ? (secteurData.T_Mai * 100).toFixed(1) : '-'),
                'ville': (this.favorite.ad_city.logement.T_Mai * 100).toFixed(1),
                'france': (this.favorite.ad_city.logement_fr.T_Mai * 100).toFixed(1),
            },
        ];
        this.compare_2 = [
            {
                'lib': 'Résidences principales',
                'quartier': (irisData != null ? (irisData.T_RP * 100).toFixed(1) : '-'),
                'secteur': (secteurData != null ? (secteurData.T_RP * 100).toFixed(1) : '-'),
                'ville': (this.favorite.ad_city.logement.T_RP * 100).toFixed(1),
                'france': (this.favorite.ad_city.logement_fr.T_RP * 100).toFixed(1),
            },
            {
                'lib': 'Résidences secondaires',
                'quartier': (irisData != null ? (irisData.T_RS * 100).toFixed(1) : '-'),
                'secteur': (secteurData != null ? (secteurData.T_RS * 100).toFixed(1) : '-'),
                'ville': (this.favorite.ad_city.logement.T_RS * 100),
                'france': (this.favorite.ad_city.logement_fr.T_RS * 100),
            },
            {
                'lib': 'Logements vacants',
                'quartier': (irisData != null ? (irisData.T_LV * 100).toFixed(1) : '-'),
                'secteur': (secteurData != null ? (secteurData.T_LV * 100).toFixed(1) : '-'),
                'ville': (this.favorite.ad_city.logement.T_LV * 100).toFixed(1),
                'france': (this.favorite.ad_city.logement_fr.T_LV * 100).toFixed(1),
            }
        ];
    }

    edit(event, fields = '') {
        if (fields == 'secteur') {
            this.iris = this.secteur;
        }
        this.setData();
    }

    toogleTabs(t) {
        this.tabs = t;
        this.setData();
    }
}
